import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  circle: {
    height: 30,
    width: 30,
    display: "flex",
    justifyContent: "center",
    borderRadius: "50%",
    zIndex: 2,
  },
  main: {
    marginTop: 20,
    marginBottom: 20,
    marginLeft: 15,
    marginRight: 15,
  },
}));

const Breadcrumb = (props) => {
  const [iterableArray, setIterableArray] = useState([]);
  const classes = useStyles();

  useEffect(() => {
    const array = [];
    // itère un nb fois = taille du breadcrumb passée en props
    for (let i = 1; i <= props.size; i++) {
      // de base, le status est future
      let newDot = { number: i, status: "future" };
      // check la valeur du current passée en props et si < , status = complete
      if (i < props.current) {
        newDot.status = "complete";
      }
      // check la valeur du current passée en props et si = , status = current
      if (i === props.current) {
        newDot.status = "current";
      }
      array.push(newDot);
    }
    setIterableArray(array);
  }, [props]);

  return (
    <div className={`status-track ${classes.main}`}>
      {iterableArray.map((dot) => (
        <div className={dot.status} key={iterableArray.indexOf(dot)}>
          <div className={classes.circle}>
            <span>{dot.number}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Breadcrumb;
